import { FormInputGroup } from 'framework/ui/layout';
import { Grid2 as Grid, Stack, Typography } from '@mui/material';
import { LinkField } from 'framework/ui/field';
import { NumberInput, useInputHelper } from 'framework/form';
import { get } from 'lodash';
import { ArtifactStorageOneFileLink, ArtifactStorageUploaderInput } from 'domain/shared/artifactStorage';
import { TemplateDocumentStorageContext } from 'domain/shared/documentStorage';

const SOWForm = ({ source }: any) => {
  const { getValue } = useInputHelper({ source });
  const docusignLink = getValue()?.docusignLink;

  return (
    <Stack spacing={2}>
      <Grid container spacing={2} size={12}>
        <Grid size={3}>
          <Typography>Signed SOW:</Typography>
        </Grid>
        <Grid size={9}>
          <FormInputGroup isVisible={data => get(data, `${source}.isDocusignLink`) === false}>
            <ArtifactStorageOneFileLink linkText="" label="" source={''} id={docusignLink} />
          </FormInputGroup>
          <FormInputGroup isVisible={data => get(data, `${source}.isDocusignLink`) === true}>
            <LinkField linkText="" label="" source={''} value={docusignLink} />
          </FormInputGroup>
        </Grid>
      </Grid>

      <Grid container spacing={2} size={12}>
        <FormInputGroup isVisible={data => get(data, `${source}.isDocusignLink`) === false}>
          <Grid size={3}>
            <TemplateDocumentStorageContext>
              <ArtifactStorageUploaderInput
                fileExtensions="pdf"
                isNewDocumentStorage
                label=""
                source={`${source}.relatedAttachments`}
              />
            </TemplateDocumentStorageContext>
          </Grid>
        </FormInputGroup>
        <FormInputGroup>
          <Grid size={3}>
            <NumberInput label="SOW number" source={`${source}.sowId`} />
          </Grid>
        </FormInputGroup>
      </Grid>
    </Stack>
  );
};
export default SOWForm;
